<template>
  <div class="question-box">
    <div v-for="(v, i) in questions" :key="i">
      <div class="top-line">
        <p>第{{i+1}}题</p>
        <div class="btns" v-if="isEdit">
          <span v-if="i!==0" @click="moveUp(v, i)">上移</span>
          <span v-if="i+1<questions.length" @click="moveDown(v, i)">下移</span>
          <span class="edit" @click="handleEdit(v.id)">修改</span>
        </div>
      </div>
      <p>
        <span>【{{formatterType('','',v.type)}}】</span>
        <span>{{v.content}}</span>
      </p>
      <div v-if="v.type!==3&&v.type!==5" class="question-item">
        <ul>
          <li v-for="s in v.options" :key="s.tab" :class="{right: (v.answer==s.tab&&v.type==1)||(v.type==2&&v.answer.includes(s.tab))}">
            <span>{{s.tab}}</span>
            <span>{{s.content}}</span>
            <span class="right-text" v-if="(v.answer==s.tab&&v.type==1)||(v.type==2&&v.answer.includes(s.tab))">正确答案</span>
          </li>
        </ul>
        <div v-if="v.type==4" class="right" style="border: 1px solid #409eff;border-radius: 4px">
          <span>答案：</span>
          <span>{{v.answer}}</span>
        </div>
      </div>
      <div v-if="v.type==3" class="question-item">
        <ul>
          <li v-for="s in JUDGEcontrols" :key="s.tab" :class="{right: v.answer==s.content}">
            <span>{{s.tab}}</span>
            <span class="right-text" v-if="v.answer==s.content">正确答案</span>
          </li>
        </ul>
      </div>
      <div v-if="v.type==5" class="question-item">
        <ul>
          <li v-for="s in v.answer" :key="s.tab" class="right">
            <span>{{s.tab}}</span>
            <span>{{s.content}}</span>
          </li>
        </ul>
      </div>
      <div>
        <span>解析：</span>
        <span>{{v.analysisContent || '暂无解析'}}</span>
      </div>
      <div class="border"></div>
    </div>
  </div>
</template>

<script>
import formatter from '@/mixin/formatter.js';
import {JUDGEcontrols} from '@/views/resource/json';
import { packgeServer } from '@/api/api'
export default {
  mixins: [formatter],
  props: {
    questions: {
      type: Array,
      require: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      JUDGEcontrols
    }
  },
  methods: {
    moveUp (item, index) {
      const json = [
        {id: item.id, sort: this.questions[index - 1].sort === item.sort ? this.questions[index - 1].sort + 5 : this.questions[index - 1].sort},
        {id: this.questions[index - 1].id, sort: item.sort}
      ]
      packgeServer.questionSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    moveDown (item, index) {
      const json = [
        {id: item.id, sort: this.questions[index + 1].sort === item.sort ? this.questions[index + 1].sort - 5 : this.questions[index + 1].sort},
        {id: this.questions[index + 1].id, sort: item.sort}
      ]
      packgeServer.questionSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    handleEdit (id) {
      let rourteUrl = this.$router.resolve({
        path: '/resource/addquestionIndex',
        query: {id}
      });
      window.open(rourteUrl.href, '_blank')
    },
  }
}
</script>

<style scoped lang='scss'>
.question-box {
  margin-top: 10px;
  text-align: left;
  line-height: 30px;
  color: #3D3D3D;
  .question-item {
    ul {
      li {
        list-style: none;
        border: 1px solid transparent;
        border-radius: 4px;
        padding: 0 10px;
        margin-bottom: 5px;
      }
    }
    li.right, div.right {
      color: #409eff;
      border-color: #409eff;
      background: #f0f7ff;
      position: relative;
      .right-text {
        position: absolute;
        right: 10px;
      }
    }
    div.right {
      padding: 0 10px;
    }
  }
  .border {
    width: 100%;
    height: 1px;
    margin: 10px 0;
    background-color: #ccc;
  }
  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      padding: 0 5px;
      color: #409eff;
      cursor: pointer;
    }
    .edit {
      color: #95d1a3;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coursePackage/components/question.vue